import {
  ColorCircleWithIcon,
  IColorCircleWithIcon,
} from '../ColorCircleWithIcon';

export interface IRoundColorContentProps extends IColorCircleWithIcon {
  name?: string;
}

export const RoundColorContent = ({
  name,
  ...props
}: IRoundColorContentProps) => {
  return <ColorCircleWithIcon placeholder={name} {...props} />;
};
